import { CustomerRow } from './CustomersV2.types';

type SpendingLimitStatusValue = CustomerRow['spending_limit_status']['value'];

/**
 * `SpendingLimitStatus.label` upstream is shared with the V1 table, so the two
 * statuses V2's designs word differently are re-worded here. Any status absent
 * keeps the API's own label.
 */
const V2_STATUS_LABELS: Partial<Record<SpendingLimitStatusValue, string>> = {
  last_approved_offer: 'Time to refresh',
  declined_offer: 'Declined',
};

export const statusLabel = (row: CustomerRow): string =>
  V2_STATUS_LABELS[row.spending_limit_status.value] ??
  row.spending_limit_status.label;
